import http from '@/plugins/axios';

export default {
  getProducts(pagination) {
    const params = {
      start: pagination.rowsPerPage * (pagination.page - 1) || 0,
      length: pagination.rowsPerPage,
      order_direction: pagination.descending ? 'desc' : 'asc',
      search: pagination.search,
      order: 'status',
    };
    return http
      .get('auto-qa/datatables', {
        params,
      })
      .then(res => res.data);
  },
  getAskedQAs(productId) {
    return http.get(`products/${productId}/auto-qa/get-asked-questions`).then(res => res.data);
  },
  generateQAs(productId) {
    return http.post(`products/${productId}/auto-qa/request-generation`).then(res => res.data);
  },
  approveQA(data) {
    const payload = {
      question: data.question,
      answer_id: data.answer_id,
      answer: data.answer,
      answer_start: data.answer_start,
      answer_end: data.answer_end,
      by_user: data.by_user,
    };
    return http
      .post(`auto-qa/${data.question_id}/approve-qa-review`, payload)
      .then(res => res.data);
  },
  rejectQA(questionId) {
    return http.post(`auto-qa/${questionId}/reject-qa-review`).then(res => res.data);
  },
  askQA(data) {
    const payload = {
      question: data.question,
    };
    return http
      .post(`products/${data.product_id}/auto-qa/ask-question`, payload)
      .then(res => res.data);
  },
  getGeneratedQAs(productId) {
    return http.get(`products/${productId}/auto-qa/get-generated-qa`).then(res => res.data);
  },
};
